import { useMemo } from 'react';
import I18n from 'I18n';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { TFlex } from 'foundations-components/transitional/components/TFlex';

// @ts-expect-error untyped import
import Any from 'customer-data-filters/filterQueryFormat/operator/Any';
import { ListIsMember, ListIsNotMember
// @ts-expect-error untyped import
} from 'customer-data-filters/filterQueryFormat/operator/Operators';
import { jsx as _jsx } from "react/jsx-runtime";
const ListOperatorSelect = ({
  value,
  onChange,
  id
}) => {
  const options = useMemo(() => {
    const field = value === null || value === void 0 ? void 0 : value.field;
    return [{
      value: 'ListIsMember',
      label: I18n.text('reporting-snowflake.filter-editor.list-membership.applied-operator-in'),
      operator: field ? ListIsMember.of(field) : null
    }, {
      value: 'ListIsNotMember',
      label: I18n.text('reporting-snowflake.filter-editor.list-membership.applied-operator-not'),
      operator: field ? ListIsNotMember.of(field) : null
    }, {
      value: 'Any',
      label: 'None',
      operator: field ? Any.of(field) : null
    }];
  }, [value === null || value === void 0 ? void 0 : value.field]);
  const currentValue = useMemo(() => {
    if (value instanceof ListIsMember) {
      return 'ListIsMember';
    }
    if (value instanceof ListIsNotMember) {
      return 'ListIsNotMember';
    }
    return 'Any';
  }, [value]);
  const handleChange = selectedValue => {
    const selectedOption = options.find(option => option.value === selectedValue);
    if (selectedOption !== null && selectedOption !== void 0 && selectedOption.operator) {
      onChange({
        target: {
          value: selectedOption.operator
        }
      });
    }
  };
  return /*#__PURE__*/_jsx(TFlex, {
    direction: "column",
    children: options.map(option => /*#__PURE__*/_jsx(RadioInput, {
      id: id ? `${id}-${option.value}` : option.value,
      name: id || 'list-operator',
      value: option.value,
      checked: currentValue === option.value,
      onChange: () => handleChange(option.value),
      children: option.label
    }, option.value))
  });
};
export default ListOperatorSelect;